import { render, staticRenderFns } from "./anleitung.vue?vue&type=template&id=2dc77287&"
import script from "./anleitung.vue?vue&type=script&lang=js&"
export * from "./anleitung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports